import React, { useEffect, useRef } from "react";
import { fromJS } from "immutable";
import Editor from "./Editor";
import "./comment-input.css";

interface CommentInputProps {
  placeholder?: string;
  editorContent?: { htmlContent: string; contents: any };
  members?: any;
  editorInputRef?: React.RefObject<any>;
  onChange?: (content: any) => void;
  className?: string;
  containerClassName?: string;
  editorClassName?: string;
  minRows?: number;
  showToolbar?: boolean;
  hideBorder?: boolean;
  lineHeightPx?: number;
  style?: React.CSSProperties;
  containerStyle?: React.CSSProperties;
}

const CommentInput: React.FC<CommentInputProps> = ({
  placeholder = "Add comment...",
  editorContent = { htmlContent: "", contents: {} },
  members = fromJS([]),
  editorInputRef,
  onChange,
  className = "",
  containerClassName = "",
  editorClassName = "",
  minRows = 1,
  showToolbar = false,
  hideBorder = true,
  lineHeightPx = 22,
  style: _style,
  containerStyle,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);

  // Force remove border after Quill renders
  useEffect(() => {
    if (!hideBorder) return;

    const removeBorder = () => {
      if (!containerRef.current) return;

      // Find all Quill elements
      const quillContainer = containerRef.current.querySelector(".ql-container.ql-snow");
      const quillContainer2 = containerRef.current.querySelector(".ql-container");
      const quillEditor = containerRef.current.querySelector(".ql-editor");

      [quillContainer, quillContainer2, quillEditor].forEach((el) => {
        if (el) {
          const htmlEl = el as HTMLElement;
          htmlEl.style.setProperty("border", "none", "important");
          htmlEl.style.setProperty("border-width", "0", "important");
          htmlEl.style.setProperty("border-style", "none", "important");
          htmlEl.style.setProperty("box-shadow", "none", "important");
          htmlEl.style.setProperty("outline", "none", "important");
        }
      });
    };

    // Apply immediately and with delays to catch Quill's dynamic rendering
    removeBorder();
    const timeout1 = setTimeout(removeBorder, 0);
    const timeout2 = setTimeout(removeBorder, 10);
    const timeout3 = setTimeout(removeBorder, 50);
    const timeout4 = setTimeout(removeBorder, 100);

    return () => {
      clearTimeout(timeout1);
      clearTimeout(timeout2);
      clearTimeout(timeout3);
      clearTimeout(timeout4);
    };
  }, [hideBorder, editorContent, members]);

  return (
    <div
      ref={containerRef}
      className={`comment-input-container ${containerClassName}`}
      style={containerStyle}
    >
      <Editor
        placeholder={placeholder}
        editorContent={editorContent}
        showToolbar={showToolbar}
        viewMode={false}
        readOnly={false}
        editorHeight="auto"
        minRows={minRows}
        lineHeightPx={lineHeightPx}
        attributes={fromJS([])}
        members={members}
        onChange={onChange}
        editorInputRef={editorInputRef}
        hideBorder={hideBorder}
        className={`comment-input-editor ${editorClassName} ${className}`}
      />
    </div>
  );
};

export default CommentInput;
